import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { param } from "~/utils/url_helper";

//TODO test
export const useWorkloadSubtasks = (params, config) => {
  return useQuery({
    ...config,
    queryKey: ["workload-subtasks", params],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/workload/subtasks?${param(params)}`,
        signal,
      }),
  });
};
